import { render, staticRenderFns } from "./LoginSelo.vue?vue&type=template&id=88e6bad2&scoped=true"
import script from "./LoginSelo.vue?vue&type=script&lang=js"
export * from "./LoginSelo.vue?vue&type=script&lang=js"
import style0 from "./LoginSelo.vue?vue&type=style&index=0&id=88e6bad2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88e6bad2",
  null
  
)

export default component.exports